import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: theme.spacing(8, 3),
    minHeight: 400,
  },
  iconWrapper: {
    width: 72,
    height: 72,
    border: `1.5px solid ${theme.palette.primary.main}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing(4),
  },
  icon: {
    fontSize: 36,
    color: theme.palette.primary.main,
  },
  heading: {
    fontSize: "1.625rem",
    fontWeight: 700,
    color: theme.palette.text.primary,
    letterSpacing: "-0.02em",
    marginBottom: theme.spacing(2),
    lineHeight: 1.2,
  },
  body: {
    fontSize: "0.9375rem",
    color: theme.palette.text.secondary,
    lineHeight: 1.7,
    maxWidth: 480,
    marginBottom: theme.spacing(1.5),
  },
  caseNumberBox: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2, 4),
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: "rgba(0,0,0,0.015)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  caseNumberLabel: {
    fontSize: "0.6875rem",
    fontWeight: 700,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
  },
  caseNumber: {
    fontSize: "1.125rem",
    fontWeight: 700,
    color: theme.palette.primary.main,
    letterSpacing: "0.04em",
  },
}));

const ThankYouACCB = ({ referenceId }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.iconWrapper}>
        <CheckCircleOutlineIcon className={classes.icon} />
      </Box>

      <Typography className={classes.heading}>
        Case Registered Successfully
      </Typography>

      {/* <Typography className={classes.body}>
        Thank you for submitting your Arbitration Request. We have received your
        application and our team will review the details provided.
      </Typography>

      <Typography className={classes.body}>
        A confirmation has been sent to the email address provided. You can
        expect to hear from our Arbitration Centre within{" "}
        <strong>2–3 working days</strong>.
      </Typography> */}

      {referenceId && (
        <Box className={classes.caseNumberBox}>
          <Typography className={classes.caseNumberLabel}>Case Number</Typography>
          <Typography className={classes.caseNumber}>{referenceId}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default ThankYouACCB;
